import React from 'react';
import PropTypes from 'prop-types';
import { KebabCase } from '../util/StringUtil';

export default class SidebarMenuItem extends React.Component {

  static propTypes = {
    isSelected: PropTypes.func,
    item: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let { item, isSelected } = this.props;

    return (
      <li className={isSelected(item) ? "selected" : ""}>
        <a
          data-object-type="sidebar-navigation"
          data-object-action={`sidebar-${KebabCase(item.title)}-select`}
          id={item.id}
          href={item.target_url}>{item.title}</a>
      </li>
    );
  }
}
